module.exports = __webpack_public_path__ + "static/media/graphql.0cb75bf2.png";